import cse1 from "./Science/cse1.PNG";
import cse2 from "./Science/cse2.PNG";
import cse3 from "./Science/cse3.PNG";
import cse4 from "./Science/cse4.PNG";
import cse5 from "./Science/cse5.PNG";
import cse6 from "./Science/cse6.PNG";
import cse7 from "./Science/cse7.PNG";
import cse8 from "./Science/cse8.PNG";

const TeacherList = [
  {
    id: 1,
    name: "Dr. Mohammed Nazim Uddin",
    image: cse1,
    category: "Science",
    Professor: "Professor & Associate Dean",
  },
  {
    id: 2,
    name: "Ishitaque Aziz Zahed",
    image: cse2,
    category: "Science",
    Professor: "Associate Professor",
  },
  {
    id: 3,
    name: "Golam Moktader Daiyan",
    image: cse3,
    category: "Science",
    Professor: "Associate Professor",
  },
  {
    id: 4,
    name: "Mohammad Toufiq Ahmed",
    image: cse4,
    category: "Science",
    Professor: "Associate Professor",
  },
  {
    id: 5,
    name: "Mashky Chowdhury Surja",
    image: cse5,
    category: "Science",
    Professor: "Lecturer",
  },
  {
    id: 6,
    name: "Arifa Sultana Zarna",
    image: cse6,
    category: "Science",
    Professor: "Lecturer",
  },
  {
    id: 7,
    name: "Saraf Anika",
    image: cse7,
    category: "Science",
    Professor: "Lecturer",
  },
  {
    id: 8,
    name: "Shah Mohammad Mominul Islam",
    image: cse8,
    category: "Science",
    Professor: "Lecturer",
  },
];

export default TeacherList;
